export function getUserDisplayName(user) {
  const name = [user?.firstName, user?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return name || user?.username || user?.email || "Signed in user";
}

export function getUserRoleLabel(role) {
  if (!role) {
    return "User";
  }
  const labels = {
    viewer: "Viewer",
    user: "User",
    admin: "Admin",
    super_admin: "Super Admin",
  };
  if (labels[role]) {
    return labels[role];
  }
  return role.charAt(0).toUpperCase() + role.slice(1);
}

export function getUserInitials(user) {
  const first = user?.firstName?.[0];
  const last = user?.lastName?.[0];
  if (first || last) {
    return `${first || ""}${last || ""}`.toUpperCase();
  }
  return (user?.username?.[0] || "?").toUpperCase();
}
